import React, { useContext } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { isSDK } from '@bingads-webui-campaign-react/sdk-utils';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { usePilotsValue } from '@bingads-webui-campaign-react/basic-context-utils';

require.context('@bingads-webui-react/rich-text-editor/src/icons');

const SupportModals = React.lazy(() => import(/* webpackMode: 'eager'  *//* webpackChunkName: "support-module" */ './components/support-module'));
const DEFAULT_FLOW_ID = 'PMAXLITE-signup';

export const SupportModalsForSignup = (props) => {
  const { i18nObjects } = props;
  const serverContext = useContext(ServerContext);
  const isPMaxLiteCopilotLiveAgentEnabled = usePilotsValue('IsPMaxLiteCopilotLiveAgentEnabled');
  let flowId = DEFAULT_FLOW_ID;
  if (isSDK()) {
    flowId = _.get(serverContext.SupportOptions, ['customSupportOptions', 'flowId']) || DEFAULT_FLOW_ID;
  }

  return (
    <SupportModals
      userContext={{
        CurrentAccount: serverContext.CurrentAccount,
        CurrentCustomer: serverContext.CurrentCustomer,
        CurrentUser: serverContext.CurrentUser,
      }}
      supportOptions={serverContext.SupportOptions}
      permissions={_.extend(
        {},
        serverContext.CCUIPilots,
        serverContext.CCUIPilots.dynamic
      )}
      helpModel={serverContext.HelpModel}
      currentLocale={serverContext.CurrentLocale}
      i18n={i18nObjects.i18n}
      featureName="PerformanceMaxLite"
      flowId={flowId}
      chatPortalClassName="ms-support-chat"
      callPortalClassName="ms-support-call"
      showRequestCall
      showRequestChat
      resourcePath={serverContext.Urls &&
        serverContext.Urls.VirtualAgentUrl}
      apexConfig={{}}
      onSubmitControlRole="link"
      isCopilotEnabled={isPMaxLiteCopilotLiveAgentEnabled}
    />
  );
};

SupportModalsForSignup.propTypes = {
  i18nObjects: PropTypes.shape({
    i18n: PropTypes.shape({
      getString: PropTypes.func,
    }),
    legacyI18n: PropTypes.shape({
      getString: PropTypes.func,
    }),
  }).isRequired,
};
